import { cn } from '../../lib/utills';
import hourglass from '/gifs/hourglass.gif';

export default function Loader({
  className,
  fullScreen = false,
}: {
  className?: string;
  fullScreen?: boolean;
}) {
  return (
    <div
      className={`${fullScreen && 'w-full h-screen flex items-center justify-center'}`}
    >
      <img
        className={cn(`w-[150px] ${className}`)}
        src={hourglass}
        alt="Loading..."
      />
    </div>
  );
}
